<template>
  <div class="wrapper">
    <div v-if="!isshow" class="no-data">暂无数据</div>
    <div class="content-top" v-if="isshow">
      <img src="../image/scan/icon-scan.png" />
      <span>溯源信息</span>
    </div>
    <div class="content-box" v-if="isshow">
      <!-- <div class="box-list">
        <div class="box-title">
          <p></p>
          <div>工单信息</div>
        </div>
        <ul>
          <li>
            <p>批次号</p>
            <p>{{ productBatchNum }}</p>
          </li>
          <li>
            <p>生产日期</p>
            <p>{{ madeDate | dateformat }}</p>
          </li>
          <li>
            <p>有效期至</p>
            <p>{{ validityDate | dateformat }}</p>
          </li>
        </ul>
      </div> -->
      <div class="box-list">
        <div class="box-title">
          <p></p>
          <div>出库信息</div>
        </div>
        <ul>
          <li>
            <p>经销商</p>
            <p>{{ receiveCompanyName }}</p>
          </li>
          <li>
            <p>出库企业</p>
            <p>{{ sendCompanyName }}</p>
          </li>
          <li>
            <p>出库日期</p>
            <p>{{ createDate | dateformat }}</p>
          </li>
        </ul>
      </div>
      <div class="box-list">
        <div class="box-title">
          <p></p>
          <div>质检信息</div>
        </div>
        <ul>
          <li>
            <p>产品合格证</p>
            <p style="color: #00cbfd" @click="scanImg">点击查看</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="modal" @click.stop="modalClose()" v-show="showImg">
      <div class="qu-img">
        <img :src="qualifier" />
        <span class="img-batch">{{ productBatchNum }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import {} from "@/common/api.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      productBatchNum: "",
      madeDate: "",
      validityDate: "",
      companyName: "",
      orderNum: "",
      language: "C",
      isshow: false,
      qualifier: "",
      showImg: false,
      sendCompanyName: "",
      receiveCompanyName: "",
      createDate: null,
    };
  },
  mounted() {
    (function (win, lib) {
      var doc = win.document;
      var docEl = doc.documentElement;
      var metaEl = doc.querySelector('meta[name="viewport"]');
      var flexibleEl = doc.querySelector('meta[name="flexible"]');
      var dpr = 0;
      var scale = 0;
      var tid;
      var flexible = lib.flexible || (lib.flexible = {});
      if (metaEl) {
        console.warn("将根据已有的meta标签来设置缩放比例");
        var match = metaEl
          .getAttribute("content")
          .match(/initial\-scale=([\d\.]+)/);
        if (match) {
          scale = parseFloat(match[1]);
          dpr = parseInt(1 / scale);
        }
      } else if (flexibleEl) {
        var content = flexibleEl.getAttribute("content");
        if (content) {
          var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
          var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
          if (initialDpr) {
            dpr = parseFloat(initialDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
          if (maximumDpr) {
            dpr = parseFloat(maximumDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
        }
      }

      if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3;
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2;
          } else {
            dpr = 1;
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1;
        }
        scale = 1 / dpr;
      }

      docEl.setAttribute("data-dpr", dpr);
      if (!metaEl) {
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        metaEl.setAttribute(
          "content",
          "initial-scale=" +
            scale +
            ", maximum-scale=" +
            scale +
            ", minimum-scale=" +
            scale +
            ", user-scalable=no"
        );
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl);
        } else {
          var wrap = doc.createElement("div");
          wrap.appendChild(metaEl);
          doc.write(wrap.innerHTML);
        }
      }

      function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
          width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + "px";
        flexible.rem = win.rem = rem;
      }

      win.addEventListener(
        "resize",
        function () {
          clearTimeout(tid);
          tid = setTimeout(refreshRem, 300);
        },
        false
      );
      win.addEventListener(
        "pageshow",
        function (e) {
          if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
          }
        },
        false
      );

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = 12 * dpr + "px";
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function (e) {
            doc.body.style.fontSize = 12 * dpr + "px";
          },
          false
        );
      }

      refreshRem();

      flexible.dpr = win.dpr = dpr;
      flexible.refreshRem = refreshRem;
      flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === "string" && d.match(/rem$/)) {
          val += "px";
        }
        return val;
      };
      flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === "string" && d.match(/px$/)) {
          val += "rem";
        }
        return val;
      };
    })(window, window["lib"] || (window["lib"] = {}));
  },
  computed: { ...mapState(["codeInfo"]) },
  created() {
    console.log(this.codeInfo);
    var url = window.location.href;
    var index = url.lastIndexOf("/");
    var str = url.substring(index + 1, url.length);
    str = str.split("?")[0];
    this.language = str.substr(0, 1);
    this.qualifier = this.codeInfo.qualifier ? this.codeInfo.qualifier : "";
    if (this.codeInfo.productExportLibrary) {
      this.isshow = true;
      this.sendCompanyName = this.codeInfo.productExportLibrary.sendCompanyName;
      this.receiveCompanyName =
        this.codeInfo.productExportLibrary.receiveCompanyName;
      this.createDate = this.codeInfo.productExportLibrary.createDate;
    } else {
      this.isshow = false;
    }
    if (this.codeInfo.productImportLibrary) {
      this.productBatchNum = this.codeInfo.productImportLibrary.productBatchNum;
      this.madeDate = this.codeInfo.productImportLibrary.madeDate;
      this.validityDate = this.codeInfo.productImportLibrary.validityDate;
      this.companyName = this.codeInfo.companyInfo.companyName;
      this.orderNum = this.codeInfo.productImportLibrary.orderNum;
    } else {
      this.isshow = false;
    }
  },
  methods: {
    scanImg() {
      if (this.qualifier) {
        this.showImg = true;
      }
    },
    modalClose() {
      this.showImg = false;
    },
  },
};
</script>
<style lang="less" scoped>
@base: 40;
.wrapper {
  html {
    font-size: 20px;
  }
  width: 100%;
  height: 100%;
  background-color: #0094ea;
  .content-top {
    margin: 0 5%;
    padding: 20px 0;
    height: 30px;
    line-height: 30px;
    img {
      width: 25px;
      height: 25px;
      margin-top: 2.5px;
    }
    span {
      vertical-align: top;
      font-size: 1rem / @base * 20;
      color: #ffffff;
      margin-left: 5px;
    }
  }
  .no-data {
    padding-top: 40%;
    font-size: 1rem / @base * 24;
    text-align: center;
    color: #ffffff;
  }
  .modal {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #000000;
    .qu-img {
      width: 86%;
      margin-left: 7%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      img {
        width: 100%;
      }
      .img-batch {
        position: absolute;
        bottom: 29%;
        left: 48%;
        font-size: 1rem / @base * 13;
        color: #3d3d3d;
      }
    }
  }
  .content-box {
    width: 90%;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    padding-bottom: 30px;
    .box-list {
      .box-title {
        padding-top: 20px;
        font-size: 1rem / @base * 18;
        color: #0094ea;
        margin-left: 20px;
        height: 30px;
        p {
          float: left;
          width: 2px;
          height: 15px;
          background-color: #0094ea;
          margin-right: 10px;
          border-radius: 2px;
        }
        div {
          float: left;
          height: 15px;
          line-height: 15px;
        }
      }
      ul {
        li {
          display: flex;
          padding: 0 25px;
          p {
            font-size: 1rem / @base * 17;
            color: #343434;
            padding: 20px 0;
          }
          p:nth-child(1) {
            width: 25%;
            text-align: justify;
            text-align-last: justify;
          }
          p:nth-child(2) {
            width: 69%;
            margin-left: 5%;
          }
        }
      }
      .content-ul {
        li {
          display: flex;
          padding: 0 25px;
          p {
            color: #343434;
            line-height: 2;
          }
          p:nth-child(1) {
            font-size: 1rem / @base * 14;
            width: 40%;
            text-align: justify;
            text-align-last: justify;
          }
          p:nth-child(2) {
            font-size: 1rem / @base * 16;
            width: 54%;
            margin-left: 5%;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/scanTraceability.vue